const regex = /^signup_/
export const getSignupAppFields = (location) => {
  try {
    const urlParams = new URLSearchParams(location.search)
    let signupParams = {}
    for (const [key, value] of urlParams.entries()) {
      if (!signupParams[key] && key.match(regex)) {
        signupParams = { ...signupParams, [key]: value }
      }
    }
    return signupParams
  } catch {
    return null
  }
}

export const getSignupAppData = (values) => {
  let signupFields = {}
  for (const [key, value] of Object.entries(values)) {
    if (!signupFields[key] && key.match(regex)) {
      signupFields = { ...signupFields, [key]: value }
    }
  }
  return signupFields
}

export const formatForMarketo = (values) => {
  return Object.entries(values)
    .map((el) => el.join("="))
    .join(",")
}
